export default __webpack_public_path__ + "static/media/logo-horizontal.fdc68d30.png";